import { LogGroup, Rect, Size } from "../.././MyHelpers";
import { ISimpleBonusCommonConfiguration, SlotGameMeta } from "../../api";
import { AudioManager } from "../../AudioManager";
import { ClientState } from "../../ClientState";
import { Money } from "../../Money";
import { RobotPlay } from "../../RobotPlay";
import { Translator } from "../../Translator";
import { SlotBonusParams } from "../Bonus/SlotBonusParams";
import { Panel } from "../panel/panel";
import { BonusPickReveal } from "../SlotGame";
import { CanvasSprite } from "../Sprite/CanvasSprite";
import { IPickBonusPickElementFactory } from "./PickBonus";
import { PickSprite } from "./PickSprite";

export interface  IPickBonusConfiguration  extends ISimpleBonusCommonConfiguration
{
	NumOFPickPerPage: number [];
	RequiredElementsToPicks:number[];
	//Jackpots:AvailableJackpotToHit [];
	RequiredJpToWin: RequiredJpToWin [];
}

export interface  RequiredJpToWin
{
	Name: string;
	RequiredToHit: number;
}

export interface  PickBonusParams extends SlotBonusParams
{

	readonly gameBonusResourcesBasePath: string;
	readonly commonBonusResourcesBasePath: string;

	//protected numberOfPicksPerPage:number [] = [];

	readonly bonusConfiguration: IPickBonusConfiguration;

	readonly pickElementFactory: IPickBonusPickElementFactory;

	readonly screenSize: Size;

	readonly audio: AudioManager;
	readonly panel: Panel;
	readonly translator:Translator;

	readonly slotGameMeta: SlotGameMeta;

	readonly robotPlay: RobotPlay;
	readonly clientState:ClientState;
	readonly jackpotRequired : boolean;
	readonly bonusAutoplay: boolean;
}



export class PickBonusPickElementParams
{
	public index: number;
	public logGroup: LogGroup;
	public displaySize: Size;
	public pickRect: Rect;
	public awardRect: Rect;
	public sprite: CanvasSprite;
	public pickSprite:PickSprite;
	
	public fontFamily: string;

	public constructor(
		index: number, 
		logGroup: LogGroup,
		displaySize: Size, 
		pickRect: Rect, 
		awardRect: Rect, 
		sprite: CanvasSprite, 
		pickSprite:PickSprite, 
		
	    fontFamily: string,
	)
	{
		this.index = index,
		this.logGroup = logGroup;
		this.displaySize = displaySize,
		this.pickRect = pickRect,
		this.awardRect = awardRect;
		this.sprite = sprite;
		this.pickSprite = pickSprite;
		this.fontFamily=fontFamily;
	}
}

export interface  PickBonusReward{
	PickType:number;
}

export interface  PickBonusCashReward extends PickBonusReward
{
	Reward:Money;
}

export interface  PickBonusJackpotReward extends PickBonusReward
{
	JackpotName:string;
	JackpotCount:number;
	WinAmount:Money;
}

export interface  PickBonusRevealValue extends BonusPickReveal {
	RevealedValue: PickBonusReward;
}

export interface  PickRevealRemaining
{
	Remaining: PickBonusReward[];
	NextPage:boolean;
}

export interface  PickBonusRevealRemaining extends PickRevealRemaining {
	//Remaining: PickBonusPick[];
	Remaining: any;
}
